import { render, staticRenderFns } from "./360ProjectReview.vue?vue&type=template&id=10d385c6&"
import script from "./360ProjectReview.vue?vue&type=script&lang=js&"
export * from "./360ProjectReview.vue?vue&type=script&lang=js&"
import style0 from "./360ProjectReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports